<template>
    <div :class="className" id="wyzwania-podatkowe">
        <section class="section title-bar">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <h2 class="title">{{ data.title }}</h2>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="columns is-centered is-multiline">
                    <div
                        class="column is-6-tablet is-3-desktop"
                        v-for="(post,key) in posts"
                        @click="$router.push('/'+$t('url-challenges')+'/'+post.slug)"
                    >
                        <div class="card card--button-more">
                            <div class="card-image">
                                <span>{{ pad(key+1) }}</span>
                                <figure class="image is-3by2">
                                    <img v-if="post.thumbnail" :src="post.thumbnail" :alt="post.title.rendered">
                                </figure>
                            </div>
                            <div class="card-content">
                                <h3 class="title">{{ post.title }}</h3>
                                <div v-if="post.excerpt" v-html="post.excerpt"></div>
                                <a class="button-more" href="#" @click.prevent>{{ $t("more") }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    computed: {
        posts(){
            return this.$store.getters.getPosts(this.$i18n.locale)
        }
    },
    methods:{
        pad(number){
            let size = 2
            var s = String(number);
            while (s.length < (size || 2)) {s = "0" + s;}
            return s;
        }
    }
}
</script>

<style scoped lang="sass">
@import "@/styles/framework/variables.sass"
@import "@/styles/framework/extends.sass"
.flex-home-wyzwania
    padding: 0
    background-color: $grey5
.card
    &:hover
        .title
            color: $pink
    .card-image
        span
            line-height: 1
            color: $white
            position: absolute
            left: $size-4
            top: $size-4
            font-weight: bold
            font-size: $size-1
            z-index: 10
            transition: color $normal
    .card-content
        .title
            margin-bottom: 0.5rem
        /deep/ p
            font-size: 0.9rem
</style>
